import { render, staticRenderFns } from "./ContactDataManager.vue?vue&type=template&id=2f8db1e0&"
import script from "./contact-data-manager.ts?vue&type=script&lang=ts&"
export * from "./contact-data-manager.ts?vue&type=script&lang=ts&"
import style0 from "./ContactDataManager.vue?vue&type=style&index=0&id=2f8db1e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports